module.exports = __webpack_public_path__ + "static/img/197_phase_function_Paper_Points.b850376.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/197_phase_function_Paper_Points.png
// module id = odjm
// module chunks = 0